import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, Grid, TextField, Typography, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { getLesseeDropdown, putLesseeApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { useDispatch } from 'react-redux';
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators';
import { regexConstants } from '../../../../constants/regEx';

const LesseeCRU = ({ editLessee, onToggleModal, params, getResponseBack,modeType }) => {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const [editLesseeData, setEditLesseeData] = useState({ ...editLessee?.data, operator_id: editLessee?.data?.operator });
    const [lesseeData, setLesseeData] = useState([]);
    const [dropDownloader,setDropDownLoader]=useState(false)
    const [error, setError] = useState({});
    const oldValue = useRef(null);
    useEffect(() => {
        if (modeType !== 'view') getLesseeID();
    }, [])

    const handelEditLessee = () => {
        let validationInputs = {};
        validationInputs = {
            lessee: editLesseeData?.lessee ? "" : "Please select Lessee",
            operator_id: editLesseeData?.same_operator_lessee === 0 ? editLesseeData?.operator_id ? "" : "Please select Operator" : "",
        }
        if (editLesseeData?.lessee?.id!=null &&editLesseeData?.lessee?.id === editLesseeData?.operator_id?.id && editLesseeData?.same_operator_lessee === 0) {
            enqueueSnackbar("please select a different operator", { variant: 'error', anchorOrigin: { horizontal: "right", vertical: "top" }, });
            return;
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, editLesseeData);
            payload = {
                ...payload,
                lessee_id: editLesseeData.lessee,
                lessee_name: editLesseeData?.lessee?.name || null
            }

            globalPutService(putLesseeApi(params,{'cross_feature_check': 'lease_details'}), payload)
                .then(async (response) => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        onToggleModal();
                        dispatch(fetchLeaseBasicDetails({ slug: params, setLoading}));
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Lessee`, success_msg: response?.data?.message, item_slug:params, payload: payload, response: response?.data })
                    } else {
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                        trackActivity('Item Edited', { page_title: `Edit Lessee`, error_msg: response?.data?.message, item_slug: params, payload: payload, response: response?.data })
                    }
                    setLoading(false);
                })
        }
        else {
                setError(validationInputs);
                trackActivity(`Item Edited`, { page_title: `Edit Lessee`, error_msg: validationInputs, })  
        }
    }

    const getLesseeID = () => {
            setDropDownLoader(true)
        globalGetService(getLesseeDropdown())
            .then(response => {
                setDropDownLoader(false)
                if (checkApiStatus(response)) {
                    setLesseeData(response?.data?.data);
                }
            })
    }


    const handelInputChange = (key, value) => {
        if (key === 'lessee') {
            setEditLesseeData({
                ...editLesseeData,
                [key]: value,
                lessee_contact_address: value?.contact_address ? value?.contact_address : "",
                lessee_contact_email: value?.contact_email ? value?.contact_email : "",
                contractual_notice_address: value?.contractual_notice_address ? value?.contractual_notice_address:"",
                lessee_contact_fax_number: value?.contact_fax_number ? value?.contact_fax_number : null,
                lessee_phone_number: value?.contact_phone_number ? value?.contact_phone_number : null,
                lessee_country_of_incorporation: value?.country_of_incorporation ? value?.country_of_incorporation : null,
                attention_to:value?.atten_to ? value?.atten_to : null,
            })
        }
        else if (key === 'same_operator_lessee' && value === 0) {
            setEditLesseeData({ ...editLesseeData, [key]: value, operator_id: null });
        }
        else if (key === 'same_operator_lessee' && value === 1) {
            setEditLesseeData({ ...editLesseeData, [key]: value, operator_id: editLesseeData?.lessee });
        }
        else if (key === "country_of_corporation") {
            setEditLesseeData({...editLesseeData,lessee: {...editLesseeData?.lessee,[key]: value}})
        }
        else {
            setEditLesseeData({ ...editLesseeData, [key]: value });
        }
    }
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType==='view'? 'View':'Edit'} Lessee`, page_type: page_type, })
  }

    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={editLessee.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'>
                 <Typography className="dialog-header-title">{modeType==='edit'?'Edit':'View'} Lessee </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                disabled={modeType==='view'}
                                options={lesseeData}
                                getOptionLabel={(option) => option?.name || ""}
                                noOptionsText={dropDownloader ? "Loading..." :"No Option Available" }
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                value={editLesseeData?.lessee || null}
                                onChange={(event, newValue) => {
                                    handelInputChange("lessee", newValue);
                                }}
                                onOpen={() => {
                                    oldValue.current = editLesseeData?.lessee || null;
                                    setEditLesseeData({ ...editLesseeData, lessee: null });
                                }}
                                onClose={(_, reason) => {
                                    if (reason !== 'selectOption') {
                                        setEditLesseeData({ ...editLesseeData, lessee: oldValue.current });
                                    }
                                }}
                                onFocus={() => setError((prev) => ({ ...prev, lessee: "" }))}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField {...params} label="Name" variant='outlined' size='small' margin='normal' required fullWidth helperText={error.lessee} error={error.lessee} slotProps={{
                                                inputLabel: { shrink: true }, input: {
                                                    ...params?.InputProps, endAdornment: (<>{dropDownloader ? (<CircularProgress color="inherit" size={20} />) : null}
                                                        {params?.InputProps?.endAdornment}
                                                    </>)
                                                }
                                            }} placeholder={oldValue.current?.name || 'Select Lessee'} /></Tooltip>
                                    )
                                }}
                            />
                        </Grid>
                        {editLesseeData?.same_operator_lessee === 0 ?
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    disabled={modeType === 'view'}
                                    options={lesseeData}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={dropDownloader ? "loading" : "No Option Available"}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    value={editLesseeData?.operator_id || null}
                                    onChange={(event, newValue) => {
                                        handelInputChange("operator_id", newValue)
                                    }}
                                    onFocus={() => setError((prev) => ({ ...prev, operator_id: "" }))}
                                    renderInput={(params) => {
                                        const selectedLabel = params?.inputProps?.value || "";
                                        return (
                                            <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                                <TextField {...params} label="Operator" variant='outlined' size='small' margin='normal' required fullWidth helperText={error.operator_id} error={error.operator_id} placeholder='Select Operator'
                                                    slotProps={{
                                                        inputLabel: { shrink: true }, input: {
                                                            ...params?.InputProps, endAdornment: (<>{dropDownloader ? (<CircularProgress color="inherit" size={20} />) : null}
                                                                {params?.InputProps?.endAdornment}
                                                            </>)
                                                        }
                                                    }}
                                                />
                                            </Tooltip>
                                        )
                                    }}
                                />
                            </Grid> : null
                        }
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLesseeData?.lessee_jurisdiction?.length > 23 ? editLesseeData?.lessee_jurisdiction : ""} placement="bottom" arrow>
                            <TextField
                                id='lessee_jurisdiction'
                                label="Jurisdiction"
                                value={editLesseeData?.lessee_jurisdiction ? editLesseeData?.lessee_jurisdiction : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("lessee_jurisdiction", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                disabled={modeType === 'view'}
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLesseeData?.habitual_base?.length > 23 ? editLesseeData?.habitual_base : ""} placement="bottom" arrow>
                            <TextField
                                id='habitual_base'
                                label="Habitual Base"
                                value={editLesseeData?.habitual_base ? editLesseeData?.habitual_base : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("habitual_base", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                disabled={modeType === 'view'}
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLesseeData?.lessee_contact_email?.length > 23 ? editLesseeData?.lessee_contact_email : ""} placement="bottom" arrow>
                                <TextField
                                    label="Contact (Email)"
                                    varient="outlined"
                                    disabled={true} size='small'
                                    margin='normal'
                                    value={editLesseeData?.lessee_contact_email || ""}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                label="Contact (Phone)"
                                varient="outlined"
                                disabled={true} size='small'
                                margin='normal'
                                value={editLesseeData?.lessee_phone_number || ""}
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Tooltip title={editLesseeData?.lessee_contact_fax_number?.length > 23 ? editLesseeData?.lessee?.contact_fax_number : ""} placement="bottom" arrow>
                                <TextField
                                    label="Contact (Fax)"
                                    varient="outlined"
                                    disabled={true} size='small'
                                    margin='normal'
                                    value={editLesseeData?.lessee_contact_fax_number || ""}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={editLesseeData?.lessee_country_of_incorporation?.length > 23 ? editLesseeData?.lessee_country_of_incorporation : ""} placement="bottom" arrow>
                            <TextField
                                label="Country of Incorporation"
                                value={editLesseeData?.lessee_country_of_incorporation ? editLesseeData?.lessee_country_of_incorporation : ""}
                                onChange={(e) => handelInputChange("country_of_corporation", e.target.value)}
                                varient="outlined"
                                size='small'
                                margin='normal'
                                disabled={true}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                fullWidth />
                            </Tooltip>
                        </Grid>
                         <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={editLesseeData?.attention_to?.length > 23 ? editLesseeData?.attention_to : ""} placement="bottom" arrow>  
                            <TextField
                                label="Attention To"
                                value={editLesseeData?.attention_to ? editLesseeData?.attention_to : ""}
                                onChange={(e) => handelInputChange("atten_to", e.target.value)}
                                varient="outlined"
                                size='small'
                                margin='normal'
                                disabled={true}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                fullWidth />
                                </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Tooltip title={editLesseeData?.lessee_contact_address?.length > 23 ? editLesseeData?.lessee_contact_address : ""} placement="bottom" arrow>  
                            <TextField
                                id='lessee_contact_address'
                                label="Contact Address"
                                value={editLesseeData?.lessee_contact_address ? editLesseeData?.lessee_contact_address : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value == "" ? handelInputChange("lessee_contact_address", e.target.value) : e.preventDefault()}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Tooltip title={editLesseeData?.contractual_notice_address?.length > 23 ? editLesseeData?.contractual_notice_address : ""} placement="bottom" arrow>  
                            <TextField
                                id='contractual_notice_address'
                                label="Contractual Notice Address"
                                value={editLesseeData?.contractual_notice_address ? editLesseeData?.contractual_notice_address : ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("contractual_notice_address", e.target.value) : e.preventDefault}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                disabled={modeType === 'view'}
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
                                    {/* <FormControlLabel id='same_operator_lessee' label="Operator Same As Lessee" control={ */}
                                    <Checkbox checked={editLesseeData?.same_operator_lessee === 1} onChange={(e) => handelInputChange("same_operator_lessee", e.target.checked ? 1 : 0)} disabled={modeType === 'view'} />
                                        {/* } ></FormControlLabel> */}
                                    <Typography className="check-item-span" fontSize='14px'>Operator Same As Lessee</Typography>
                                </Box>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button className='cancel-btn' variant='outlined' disabled={isLoading} size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); handelEditLessee(); }}> {isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default LesseeCRU;